import { render } from "./notification-table.vue?vue&type=template&id=9a5ac116&scoped=true"
import script from "./notification-table.vue?vue&type=script&lang=js"
export * from "./notification-table.vue?vue&type=script&lang=js"

import "./notification-table.vue?vue&type=style&index=0&id=9a5ac116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5ac116"]])

export default __exports__